import { render, staticRenderFns } from "./archives-cover.vue?vue&type=template&id=2f2ab52a&"
import script from "./archives-cover.vue?vue&type=script&lang=js&"
export * from "./archives-cover.vue?vue&type=script&lang=js&"
import style0 from "./archives-cover.vue?vue&type=style&index=0&id=2f2ab52a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports